import styled from "styled-components";
import { Icon, Props } from "../Icon";
const Wrapper = styled.svg``;

export const XIconOutlined = (props: Props) => {
  return (
    <Wrapper
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </Wrapper>
  );
};
